var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 3,
    y: 3,
    fill: "#fff",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6H9Zm23.5 16.555c1.283 0 2.333-1.1 2.333-2.444 0-1.344-1.05-2.444-2.333-2.444-1.283 0-2.333 1.1-2.333 2.444 0 .22.023.428.081.623l-4.141 4.351A1.973 1.973 0 0 0 25.5 22c-.21 0-.42.024-.607.085l-2.975-3.116c.059-.196.082-.416.082-.636 0-1.344-1.05-2.444-2.333-2.444-1.284 0-2.334 1.1-2.334 2.444 0 .22.024.44.082.636l-5.32 5.561a1.9 1.9 0 0 0-.595-.086c-1.283 0-2.333 1.1-2.333 2.445 0 1.344 1.05 2.444 2.333 2.444 1.283 0 2.333-1.1 2.333-2.444 0-.22-.023-.428-.081-.623l5.308-5.574c.187.061.397.086.607.086.21 0 .42-.025.606-.086l2.975 3.117a2.256 2.256 0 0 0-.081.635c0 1.345 1.05 2.445 2.333 2.445 1.283 0 2.333-1.1 2.333-2.445 0-.22-.023-.44-.081-.635l4.153-4.339c.187.061.385.085.595.085Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticMobile);
export default __webpack_public_path__ + "static/media/statistic_mobile.3adbad0b4ddc6bd0550ddea93fc9b07a.svg";
export { ForwardRef as ReactComponent };